module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Landing-Page-w960.91f9f631.jpg";